import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DocumentReader, FieldDataType, View } from 'src/app/modules/core/store/models';
import * as fromLists from 'src/app/modules/cop/store/lists';
import * as fromCop from 'src/app/modules/cop/store/cop';
import { Store } from '@ngrx/store';
import moment from 'moment';
import { DynamicField } from 'src/app/modules/core/components/fields/dynamic-field';
import { GUID_EMPTY } from '@app/core/constants';
import { Card, CardView } from 'src/app/modules/cop/store/lists/models/card.model';
import { DatasetSubtype, DatasetType } from 'src/app/modules/core/store/models/dataset.model';
import { DataFormattingService } from 'src/app/modules/cop/services/format/data-formatting.service';
import { RelatedDocumentCard } from '../../related-ducument-model';
import { MAX_CARD_VIEW_CONTROLS } from '@app/core/constants';

@Component({
    selector: 'topo-related-incident-card',
    templateUrl: './incident-card.component.html',
    styleUrls: ['./incident-card.component.scss'],
    standalone: false
})
export class RelatedIncidentCardComponent implements OnInit {
  @Input() card: RelatedDocumentCard;
  @Input() isActive: boolean;
  @Output() click: EventEmitter<RelatedDocumentCard> = new EventEmitter();
  @Output() zoomToDocument: EventEmitter<RelatedDocumentCard> = new EventEmitter();

  imageUrl: any;
  address: string;
  location: any;
  summary: string;
  DatasetType = DatasetType;
  DatasetSubtype = DatasetSubtype;
  typeName: string;
  postedDateTime: any;
  postedElapsedTime: any;
  categoryName: string;
  documentControls: DynamicField[] = [];
  assetName: string;
  customFieldsSet: boolean;
  truncatedView: View;
  encodedImage: string;
  severityText: string;
  guidEmpty = GUID_EMPTY;

  constructor(private dataFormattingService: DataFormattingService, private store: Store<any>) {}

  ngOnInit(): void {
    const reader = new DocumentReader(this.card.document);
    const provider = reader.provider?.toLowerCase() || 'notFound';

    this.customFieldsSet = this.card?.view?.controls.length > 0;

    if (this.card?.view?.controls?.length > MAX_CARD_VIEW_CONTROLS) {
      this.truncatedView = {
        ...this.card?.view,
        controls: this.card?.view?.controls.slice(0, MAX_CARD_VIEW_CONTROLS)
      };
    } else {
      this.truncatedView = this.card?.view;
    }

    this.summary =
      reader.emailSubject || reader.summary || reader.title || reader.name || reader.content || reader.getFieldValue('display_name');
    if (this.summary?.length > 150) {
      this.summary = this.summary.slice(0, 150);
    }

    this.encodedImage = reader.getFieldValue('snapshot');

    this.address = reader.address;
    this.assetName = this.summary;

    this.categoryName = reader?.getFieldValue('category');

    this.typeName = this.card?.layer?.name;
    this.categoryName = reader?.getFieldValue('number');
    this.severityText = reader?.getFieldValue('severity_text');

    if (!!this.card?.dataset?.schema) {
      if (!!reader.getFieldValue('image')) {
        const imageField = this.card?.dataset?.schema.fields.find(f => f.dataType === FieldDataType.Image);
        if (!!imageField) {
          this.imageUrl = reader.getFieldValue(imageField.systemName);
        }
      } else {
        this.imageUrl = reader.getFieldValue('image');
      }

      let layerGeoField = this.card?.layer?.displayOptions?.geoFieldsToDisplay?.length > 0 ? this.card?.layer?.displayOptions?.geoFieldsToDisplay[0] : null;

      const geoField =
        this.card?.dataset?.schema.fields.find(f => f.dataType === FieldDataType.Geometry && f.systemName === layerGeoField) ??
        this.card?.dataset?.schema.fields.find(f => f.dataType === FieldDataType.Geometry && f.settings?.defaultGeometry === true) ??
        this.card?.dataset?.schema.fields.find(f => f.dataType === FieldDataType.Geometry);

      if (!!geoField) {
        const geoValue = reader.getFieldValue(geoField.systemName);
        if (!!geoValue) {
          this.location = this.dataFormattingService.getLatLngForDisplay(geoValue);
        } else {
          this.location = null;
        }
      } else {
        this.location = null;
      }
    }

    let posted = reader.posted;

    if (!posted) {
      const val = reader.getFieldValue('incident_date');
      posted = !!val ? moment(val) : null;
    }

    if (!posted) {
      const val = reader.getFieldValue('email_date');
      posted = !!val ? moment(val) : null;
    }

    if (!posted) {
      posted = reader.dateCreated;
    }

    if (!!posted) {
      this.postedDateTime = this.dataFormattingService.getPostedDateDisplay(posted);
      this.postedElapsedTime = posted.from(new Date());
    }
  }

  clickCard() {
    this.click.emit(this.card);
  }

  onZoomToDocument() {
    this.zoomToDocument.emit(this.card);
  }
}
